<div class="flex justify-between px-6 py-5">
    <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Browse Categories</p>
</div>

<div class="border border-[#E2E8F0] space-y-2 p-4">
    @for (category of groupCategoriesSignal(); track category.id) {
        <button
            type="button"
            class="px-3 py-1 mx-1 rounded-full border text-[0.8rem] font-medium transition duration-150"
            [ngClass]="isCategorySelected(category) ? 'active-tag' : 'inactive-tag'"
            (click)="toggleCategory(category)">
            {{ category.name }}
        </button>
    }
</div>

<mat-dialog-actions class="gap-3">
    <button type="button" class="white-border-button p-4" (click)="onCancel()">Cancel</button>
    <button type="submit" class="border-button p-4" (click)="confirmSelection()">Done</button>
</mat-dialog-actions>
